import React, { Component } from "react";
import PropTypes from "prop-types";
import { Alert, Input } from "reactstrap";
import { Button } from "reactstrap";
import LoginLogo from "../../../assets/img/brand/login-logo.png";
import achievaLogo from "../../../assets/img/brand/achieva-logo.png";
import { Navigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { getToken, ShowErrorAlert } from "../../Common/GlobalSession";

class ResetPassword extends Component {
  static propTypes = {
    auth: PropTypes.object,
    history: PropTypes.object,
    prefillEmail: PropTypes.string,
  };
  state = {
    email: this.props.prefillEmail || "",
    company_logo: localStorage.getItem("company_logo"),
    loading: false,
  };
  async componentWillMount() {
    if (
      this.state.company_logo === null ||
      this.state.company_logo === "" ||
      this.state.company_logo === undefined
    ) {
      await this.getCompanyLogo();
    }
  }
  updateEntityActivity = async () => {
    let tokenStr = getToken();
    var inputobj = {
      auditActivityType: "UA",
      logType: "I",
      activity: "FORGOT PASSWORD",
      entityId: null,
      growthPlanId: null,
      goalTagId: null,
      actionTagId: null,
      meetingId: null,
      page: "",
      auditText: "",
      auditValue: null,
      auditMessage: "User has clicked forgot password",
      auditLink: "",
      email: sessionStorage.getItem("ForgotPasswordEmailId"),
    };
    await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/updateEntityActivity",
      data: inputobj,
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        return res;
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          ShowErrorAlert(4, error.response.data.error.message);
        }
      });
  };
  updateCognitoStatusInDB = async () => {
    var email = sessionStorage.getItem("ForgotPasswordEmailId");
    await axios({
      method: "post",
      url: process.env.REACT_APP_API_END_POINT + "/updateCognitoStatuByEmail",
      data: {
        email: email,
      },
    })
      .then((Response) => Response)
      .catch(function (error) {});
  };
  forgotPassword = async (e) => {
    e.preventDefault();
    const email = this.state.email.trim().toLowerCase();
    if (email === "") {
      this.setState({ error: "Enter valid EmailId" });
      return false;
    }
    this.setState({ loading: true });
    try {
      await axios({
        url: process.env.REACT_APP_API_END_POINT + "/forgetPassword",
        method: "POST",
        data: { email },
      })
        .then(async (res) => {
          if (res.data && res.data.header && res.data.header.errorCode === 0) {
            if (res.data.result.status === 0) {
              this.setState({ error: res.data.result.errorMsg, loading: false });
            } else {
              sessionStorage.setItem("ForgotPasswordEmailId", email);
              // await this.updateEntityActivity();
              this.setState({ error: false, loading: false });
              toast.success("A password reminder has been sent to your email.");
              window.location.href = "#/login";
            }
          }
        })
        .catch((err) => {
          console.log("error", err);
          this.setState({ loading: false });
        });
    } catch (e) {
      console.log("error", e);
      this.setState({ loading: false });
    }
  };

  getCompanyLogo = async () => {
    this.setState({ company_logo: LoginLogo });
  };

  render() {
    let { company_logo, error, loading, email } = this.state;
    return (
      <div className="d-flex flex-column align-items-center justify-content-center login-section">
        <div className="login-container login-form-fields">
          <form onSubmit={this.forgotPassword}>
            <div className="login-logo">
              <img
                src={company_logo ? company_logo : ""}
                className="img-fluid"
              />
            </div>
            <p className="text-white text-center mt-3 mb-4 reset-text">
              Please reset your password. <br /> Enter your email below and we
              will send you a reminder.
            </p>

            <div className="mb-2">
              <Input
                type="email"
                name="email"
                placeholder="Email"
                autoComplete="new-password"
                className="form-control"
                value={email}
                onChange={(e) =>
                  this.setState({ email: e.target.value, error: "" })
                }
              />
            </div>

            {error && (
              <Alert className="alertMessage" color="warning">
                {error}
              </Alert>
            )}

            <Button
              className="btn-block btn btn-primary resetsubmit w-100 mt-2"
              type="submit"
              disabled={loading}
            >
              {loading && (
                <i className="fa fa-spinner fa-spin me-2" />
              )}
              Send Reminder
            </Button>

            <Button
              color="link"
              className="btn-block w-100 mt-2"
              tag={Link}
              to="/login"
            >
              Back to Login
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

const ResetPasswordWithLocation = (props) => {
  const location = useLocation();
  const prefillEmail = (location.state && location.state.email) || "";
  return <ResetPassword {...props} prefillEmail={prefillEmail} />;
};

export default ResetPasswordWithLocation;
